<template>
  <div>
    <!-- <p class="title mb-3">Cumalative Growth of Rs 1,20,000 invested through GWS</p>
    <p class="subheading">(CAGR of 96.74% since 2012)</p> -->
    <!-- <canvas id="cummilativeChart"></canvas> -->
    <div class="cumalative">
      <img src="../assets/Astral.jpg" class="img-responsive" alt="Astral stock price growth chart, Grow With Stocks recommendation">
      <img src="../assets/cera.jpeg" class="img-responsive" alt="Cera Sanitaryware stock price growth chart, Grow With Stocks recommendation">
    </div>
  </div>
</template>

<script>
  import Chart from "chart.js";
  export default {
    name: "CummilativeGraph",
    mounted() {
      var ctx = document.getElementById("cummilativeChart").getContext("2d");
      var myChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: [2012, 2013, 2014, 2015, 2016, 2017, 2018],
          datasets: [
            {
              fill: false,
              label: "Portfolio Growth ( Grow With Stocks )",
              data: [
                120000,
                427200,
                2157360,
                3430202.4,
                4665075.264,
                6764359.133,
                6967289.907
              ],
              borderColor: "#31cc9a",
              borderWidth: 5,
              backgroundColor: "#31cc9a"
            },
            {
              fill: false,
              label: "Portfolio Growth ( Sensex Mid Cap )",
              data: [
                120000,
                152072.7273,
                137629.0909,
                234327.2727,
                227345.4545,
                280363.6364,
                378763.6364
              ],
              borderColor: "#ff0000",
              borderWidth: 5,
              backgroundColor: "#ff0000"
            }
          ]
        },
        options: {
          legend: {
            position: "bottom",
            labels: {
              boxWidth: 30
            }
          },
          aspectRatio: 1.45,
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: "rgba(0, 0, 0, 0.0)"
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(0, 0, 0, 0.1)"
                }
              }
            ]
          }
        }
      });
    }
  };
</script>

<style <style lang="scss" scoped>
  .cumalative{
    img{
      width: 100%;
    }
  }
  p {
    text-align: center;
  }
  @media only screen and (max-width: 320px) {
    .title {
      font-size: 16px !important;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/CummilativeGraph.vue